<script>
    import { createEventDispatcher } from 'svelte';
    import { onMount } from 'svelte';
    import { db } from './stores.js';


    const dispatch = createEventDispatcher();
    let videoLink;
    let youTubeChannelLink;

    function tryAgain() {
        dispatch('cancel', {
            text: ''
        });
    }

    function goLive(){
        if (videoLink){
            dispatch('confirm', {
                text: videoLink
            });
        };
    }

    onMount( async()=> {
        $db.collection("keys").doc('environment')
            .onSnapshot(function(doc) {
                youTubeChannelLink = doc.data().YOUTUBE_CHANNEL_URL;
            });
    });

</script>
<div class="confirm-container">
    <h1>Streaming to YouTube</h1>
    Make sure video is streaming to <a href={youTubeChannelLink} target="_blank">{youTubeChannelLink}</a>
    <br/>If not, click Try Again.
    <br/>*Note* May need to refresh YouTube page a couple of times for video to show up.
    <h2>Copy Video link here:</h2>
    <input bind:value={videoLink}>
    <div id="optionsContainer">
        <button on:click={tryAgain}>Try again</button> <button on:click={goLive} disabled={!videoLink}>Go Live!</button>
    </div>

</div>

<style>
    .confirm-container{
        padding: 40px;
        width: 100%;
        max-width: 500px;
        height: 300px;
        background-color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    #optionsContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
</style>